<template>
  <el-dialog
    title="理赔"
    v-bind="$attrs"
    destroy-on-close
    custom-class="claim"
    center
    v-on="$listeners"
    @open="getClaim"
  >
    <ul class="claim-list">
      <li
        v-for="(claim, index) in claimList"
        :key="claim.id"
      >
        <div class="party-name">
          当事人{{ index + 1 }} {{ claim.name }}
        </div>
        <el-form
          ref="claimForm"
          :model="claim"
          inline
          :rules="rules"
        >
          <el-form-item
            label="保单号"
            prop="policyNumber"
          >
            <el-input
              v-model="claim.policyNumber"
              placeholder="请输入保单号"
            />
          </el-form-item>
          <el-form-item
            label="保险公司"
            prop="insuranceCompanyId"
          >
            <dict-select
              v-model="claim.insuranceCompanyId"
              type="insurance_company"
            />
          </el-form-item>
          <el-form-item
            label="理赔金额"
            prop="claimAmount"
          >
            <el-input
              v-model="claim.claimAmount"
              type="number"
              placeholder="请输入理赔金额"
            />
          </el-form-item>
          <el-form-item
            label="费用信息"
            prop="claim"
          >
            <el-select v-model="claim.claim" placeholder="请选择费用信息">
              <el-option
                label="未结清"
                :value="0">
              </el-option>
              <el-option
                label="已结清"
                :value="1">
              </el-option>
              <el-option
                label="部分结清"
                :value="2">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </li>
    </ul>
    <template #footer>
      <el-button
        icon="el-icon-close"
        :disabled="loading"
        @click="$emit('update:visible', false)"
      >
        取消
      </el-button>
      <el-button
        icon="el-icon-check"
        type="primary"
        :loading="loading"
        @click="claim"
      >
        确认
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import { getClaim, claim } from '@/api/accident/edit';
import DictSelect from '@/views/accident/components/dict-select';
export default {
  components: { DictSelect },
  props: {
    accidentId: {
      type: String,
      default:() => ''
    },
  },
  data() {
    return {
      claimList: [],
      rules: {
        claimAmount: [{ required: true, message: '请输入理赔金额' }],
        claim: [{required: true, message: '请选择费用信息'}]
      },
      loading: false,
    };
  },
  methods: {
    getClaim() {
      getClaim(this.accidentId).then(({ data }) => {
        this.claimList = data;
      });
    },
    claim() {
      this.loading = true;
      Promise.all(this.$refs.claimForm.map((claimForm) => claimForm.validate()))
        .then(() => claim(this.claimList))
        .then(() => {
          this.$emit('ok');
          this.$emit('update:visible', false);
          this.$message.success('理赔成功');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.claim {
  .claim-list {
    list-style: none;
  }
  .party-name {
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 400;
    color: #004dbe;
    line-height: 16px;
  }
}
</style>